import api from './api';

// Common utility endpoints
export const uploadFile = (file, endpoint = '/api/admin/uploadfile') =>
  api.post(endpoint, file, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then(r => r.data)
    .catch(error => {
      console.error('Upload file error:', error);
      throw error;
    });

export const getCountiesAndCities = () =>
  api.get('/api/admin/getcountiesandcities')
    .then(r => r.data)
    .catch(error => {
      console.error('Get counties and cities error:', error);
      throw error;
    });

export const getAddressAutocomplete = (input) =>
  api.post('/api/admin/getaddressautocomplete', { input })
    .then(r => r.data)
    .catch(error => {
      console.error('Address autocomplete error:', error);
      throw error;
    });

export const getCounties = () =>
  api.post('/api/masters/getcounties?apikey=1GPMTGT9ZCNAZPA91BH', {})
    .then(r => r.data)
    .catch(error => {
      console.error('Get counties error:', error);
      throw error;
    });

export const getCities = (county) =>
  api.post('/api/masters/getcities?apikey=1GPMTGT9ZCNAZPA91BH', { county })
    .then(r => r.data)
    .catch(error => {
      console.error('Get cities error:', error);
      throw error;
    });

export const getAddresses = (params) =>
  api.post('/api/admin/getaddresses', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get addresses error:', error);
      throw error;
    });

export const getClientsDriversCategoryCount = (params) =>
  api.post('/api/admin/getclientsdrivercategorycount', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get clients drivers category count error:', error);
      throw error;
    });

export const getCityCounts = (params) =>
  api.post('/api/admin/getcitycounts', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get city counts error:', error);
      throw error;
    });

export const getAllCities = () =>
  api.get('/api/admin/getallcities')
    .then(r => r.data)
    .catch(error => {
      console.error('Get all cities error:', error);
      throw error;
    });
